import AnimatedMessageFlowBehavior from './AnimatedMessageFlowBehavior';
import AnimatedSequenceFlowBehavior from './AnimatedSequenceFlowBehavior';

export default {
  sequenceFlowBehavior: [ 'type', AnimatedSequenceFlowBehavior ],
  messageFlowBehavior: [ 'type', AnimatedMessageFlowBehavior ]
};